/* eslint-disable */
import { api } from './../../api.js';

const state = {

};

const getters = {

};

const mutations = {
};

const actions = {
    updateProfile: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('profile', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getUserNotifications: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('notificaciones', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    readUserNotifications: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('notificaciones/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    readUserAllNotifications : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('notificaciones/all', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    resetPassword : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('reset-password/' + data.token, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    sendResetPassword : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('reset-password/send', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/UserModule.js